export default __webpack_public_path__ + "static/media/cloud-5946381_1920.aee1f8d0.jpg";